import React, { useContext } from 'react';

import { FormContext, FormField } from '@gogame/form';

import { PARTNER } from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/constants';
import { loadPartners } from 'scenes/CustomAudiences/PartnerAudiences/sources/fields';

const PartnerField = ({ depends }) => {
  const { validateField } = useContext(FormContext);
  const dataRef = React.useRef();

  const handleValidatePartner = async (value) => {
    const currentOption = dataRef.current?.find((el) => el.id === value);
    if (!currentOption?.isAllow) {
      return 'Not supported for networks or platforms in this audience';
    }
  };

  const handleDataLoad = ({ name, data }) => {
    dataRef.current = data;
    validateField(name);
  };

  return (
    <FormField.Const
      name={PARTNER}
      depends={depends}
      validate={handleValidatePartner}
      source={loadPartners}
      onDataLoad={handleDataLoad}
      padding={0}
    />
  );
};

export default PartnerField;
